<section>
	<ng-container *ngIf="sessionListDataSource.isFiltered$ | async; else notFiltered">
		<ngx-zero-state class="zero-state-filtered">
			<div zero-state-graphic>
				<img src="https://staticassets.goreact.com/Sparkles.svg" alt="No Results">
			</div>
			<p zero-state-title translate="session-zero-state_no-videos"></p>
			<p zero-state-subtext translate="session-zero-state_no-videos-change-filters-subtext"></p>
		</ngx-zero-state>
	</ng-container>

	<ng-template #notFiltered>
		<ng-container [ngSwitch]="getZeroStateStatus()">
			<ngx-zero-state class="zero-state-live" *ngSwitchCase="zeroStates.BATCH_CREATE_SESSION">
				<div zero-state-graphic>
					<img src="https://staticassets.goreact.com/Sparkles.svg" alt="No Results">
				</div>
				<p zero-state-title translate="session-zero-state_live-review-title"></p>
				<p zero-state-subtext [innerHTML]="
					'session-zero-state_live-review-subtext' | translate:{
						activityName: getActivityName()
					}">
				</p>
				<div zero-state-body>
					<span
						[tabindex]="(canStartActivity$$ | async) ? -1 : 0"
						[matTooltip]="getSessionCreationDisabledMessage$$ | async"
						[matTooltipDisabled]="canStartActivity$$ | async"
						[attr.aria-disabled]="(canStartActivity$$ | async) === false"
						matTooltipPosition="above"
						role="button">
						<button
							class="btn secondary-btn create-videos-btn"
							translate="activity-view_create-videos"
							[disabled]="(canStartActivity$$ | async) === false"
							[attr.aria-hidden]="(canStartActivity$$ | async) === false"
							(click)="createBatchSessions()">
						</button>
					</span>

					<span
						[tabindex]="(canStartActivity$$ | async) ? -1 : 0"
						[matTooltip]="getSessionCreationDisabledMessage$$ | async"
						[matTooltipDisabled]="canStartActivity$$ | async"
						[attr.aria-disabled]="(canStartActivity$$ | async) === false"
						matTooltipPosition="above"
						role="button">
						<button
							class="btn secondary-btn start-activity-btn"
							translate="session-zero-state_start-activity"
							data-cy="add-video"
							(click)="startActivity.emit()"
							[disabled]="(canStartActivity$$ | async) === false"
							[attr.aria-hidden]="(canStartActivity$$ | async) === false">
						</button>
					</span>
				</div>
			</ngx-zero-state>

			<ngx-zero-state class="zero-state-no-video" *ngSwitchCase="zeroStates.NO_VIDEOS">
				<div zero-state-graphic>
					<img src="https://staticassets.goreact.com/Sparkles.svg" alt="No Results">
				</div>
				<p zero-state-title translate="session-zero-state_no-videos"></p>
				<p zero-state-subtext translate="session-zero-state_no-videos-instructor-subtext"></p>
				<div zero-state-body>
					<button
						class="link-btn view-instructions-btn" href="#"
						data-cy="view-instructions"
						(click)="viewInstructions.emit()"
						translate="session-zero-state_view_instructions">
					</button>
					<span
						[tabindex]="(canStartActivity$$ | async) ? -1 : 0"
						[matTooltip]="getSessionCreationDisabledMessage$$ | async"
						[matTooltipDisabled]="canStartActivity$$ | async"
						[attr.aria-disabled]="(canStartActivity$$ | async) === false"
						matTooltipPosition="above"
						role="button">
						<button
							class="btn secondary-btn start-activity-btn"
							translate="session-zero-state_start-activity"
							data-cy="add-video"
							(click)="startActivity.emit()"
							[disabled]="(canStartActivity$$ | async) === false"
							[attr.aria-hidden]="(canStartActivity$$ | async) === false">
						</button>
					</span>
				</div>
			</ngx-zero-state>

			<ngx-zero-state class="zero-state-start-activity" *ngSwitchCase="zeroStates.START_ACTIVITY">
				<div zero-state-graphic>
					<img src="https://staticassets.goreact.com/Sparkles.svg" alt="No Results">
				</div>
				<p zero-state-title translate="session-zero-state_start-activity"></p>
				<p zero-state-subtext translate="session-zero-state_no-videos-presenter-subtext"></p>
				<div zero-state-body>
					<button
						class="link-btn view-instructions-btn" href="#"
						data-cy="view-instructions"
						(click)="viewInstructions.emit()"
						translate="session-zero-state_view_instructions">
					</button>
					<span
						[tabindex]="(canStartActivity$$ | async) ? -1 : 0"
						[matTooltip]="getSessionCreationDisabledMessage$$ | async"
						[matTooltipDisabled]="canStartActivity$$ | async"
						[attr.aria-disabled]="(canStartActivity$$ | async) === false"
						matTooltipPosition="above"
						role="button">
						<button
							class="btn primary-btn start-activity-btn"
							translate="session-zero-state_start-activity"
							data-cy="add-video"
							(click)="startActivity.emit()"
							[disabled]="(canStartActivity$$ | async) === false"
							[attr.aria-hidden]="(canStartActivity$$ | async) === false">
						</button>
					</span>
				</div>
			</ngx-zero-state>
		</ng-container>
	</ng-template>
</section>
